import type { SVGProps } from "react";
import * as React from "react";
const SvgGithubWhite = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M12 2C6.475 2 2 6.503 2 12.063c0 4.453 2.862 8.214 6.838 9.547.5.088.687-.213.687-.478 0-.239-.013-1.031-.013-1.874-2.512.466-3.162-.616-3.362-1.182-.113-.29-.6-1.183-1.025-1.422-.35-.188-.85-.654-.013-.666.788-.013 1.35.73 1.538 1.031.9 1.522 2.338 1.095 2.912.83.088-.654.35-1.094.638-1.346-2.225-.251-4.55-1.12-4.55-4.968 0-1.095.387-2 1.025-2.705-.1-.251-.45-1.283.1-2.666 0 0 .837-.265 2.75 1.031.8-.226 1.65-.34 2.5-.34.85 0 1.7.114 2.5.34 1.912-1.308 2.75-1.031 2.75-1.031.55 1.383.2 2.415.1 2.666.637.705 1.025 1.598 1.025 2.705 0 3.861-2.337 4.717-4.562 4.968.362.315.675.919.675 1.862 0 1.346-.013 2.428-.013 2.767 0 .265.188.579.688.478C19.137 20.277 22 16.503 22 12.063 22 6.503 17.525 2 12 2Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgGithubWhite;
